/**
 * Aletyn Identity: mainland China phone-only configuration.
 *
 * All phone-input flows are pinned to +86 by default. The country selector
 * is disabled for now (matches the plan `plan.md` Stage B-1). When we later
 * want to re-open other regions, flip `lockCountry` to false and remove the
 * forced override in SmartInputField.
 */
export const ALETYN_CHINA_PHONE_ONLY = {
  /** Country calling code, no leading +. */
  countryCode: '86',
  /** Displayed prefix in the UI. */
  displayPrefix: '+86',
  /** When true the selector renders but is non-interactive. */
  lockCountry: true,
};
